import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Card, Spinner, EmptyState, JobIdentity } from "@/components/bits";
import StatusBadge from "@/components/StatusBadge";
import { Search as SearchIcon } from "lucide-react";

export default function SearchResults() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const q = params.get("q") || "";
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!q) return;
    setLoading(true);
    api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [q]);

  const jobs = data?.jobs || [];
  const receivings = data?.receivings || [];
  const empty = jobs.length === 0 && receivings.length === 0;

  return (
    <div>
      <PageHeader title="Hasil Pencarian" subtitle={`Kata kunci: "${q}"`} />
      {loading ? <Spinner /> : empty ? <EmptyState title="Tidak ditemukan" subtitle="Coba Nopol, No Claim, No SPK, atau Part Number." icon={SearchIcon} /> : (
        <div className="space-y-6">
          {jobs.length > 0 && (
            <div>
              <h3 className="font-head font-semibold text-gray-900 mb-2">Jobs / SPK ({jobs.length})</h3>
              <div className="grid gap-2">
                {jobs.map((j) => (
                  <Card key={j.id} className="p-4 cursor-pointer hover:shadow-sm" onClick={() => navigate(`/jobs/${j.id}`)} data-testid={`search-job-${j.id}`}>
                    <div className="flex items-center justify-between gap-2">
                      <JobIdentity job={j} />
                      <StatusBadge status={j.status} />
                    </div>
                    <div className="text-xs text-gray-400 mt-2">{j.vehicle_brand} {j.vehicle_type} • {j.job_number}</div>
                  </Card>
                ))}
              </div>
            </div>
          )}
          {receivings.length > 0 && (
            <div>
              <h3 className="font-head font-semibold text-gray-900 mb-2">Receiving ({receivings.length})</h3>
              <div className="grid gap-2">
                {receivings.map((r) => (
                  <Card key={r.id} className="p-3 flex items-center justify-between">
                    <div>
                      <div className="font-mono-data font-semibold">{r.nopol}</div>
                      <div className="text-xs text-gray-400">{(r.items || []).map((i) => i.part_number).join(", ")} • {r.receiving_number || "no-rcv"}</div>
                    </div>
                    <StatusBadge status={r.match_status} />
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
